import { Icon } from "@alternative/components";
import React from "react";
import { useRecoilValue } from "recoil";
import { designListState } from "../../recoil/filemanager/atoms";

const Breadcrumbs = () => {
  const { selectedFolders } = useRecoilValue(designListState);
  const splitPath = selectedFolders[0] ? selectedFolders[0].fullPath.split("/") : [];
  return (
    <div className="at-breadcrumb-container">
      {splitPath.map((part, i) => (
        <div key={i} className="at-breadcrumb">
          <span>{part}</span>
          {i < splitPath.length - 1 && <Icon icon="chevron-right" />}
        </div>
      ))}
    </div>
  );
};

export default Breadcrumbs;
